<template>
  <div class="vg-thankyou-rich-content-host">
    <div v-if="showContent" class="rich-offer-content vg-thankyou-rich-content">
      <div class="rich-offer-html" v-html="html"></div>
    </div>
  </div>
</template>

<script>
import { extractTrustedScripts } from "@/services/scriptOriginAllowList";
import { useConfirmationContextStore } from "@/store/confirmationContext";

export default {
  name: "CheckoutThankYouRichContent",
  created() {
    this.injectedScripts = [];
  },
  computed: {
    html() {
      const content = useConfirmationContextStore().activeSettings?.richContent;
      return typeof content === "string" ? content : "";
    },
    showContent() {
      const store = useConfirmationContextStore();
      return (
        store.resolved && !store.hasExtrasellOffers && Boolean(this.html.trim())
      );
    },
    activeHtml() {
      return this.showContent ? this.html : "";
    },
  },
  mounted() {
    this.syncHostVisibility();
    this.$nextTick(() => {
      this.safeInjectTrustedScripts();
    });
  },
  unmounted() {
    this.safeRemoveInjectedScripts();
  },
  watch: {
    activeHtml() {
      this.safeRemoveInjectedScripts();
      this.$nextTick(() => {
        this.safeInjectTrustedScripts();
        this.syncHostVisibility();
      });
    },
  },
  methods: {
    syncHostVisibility() {
      this.$nextTick(() => {
        const panel = this.$el?.closest?.(
          ".vg-confirmation-panel--thankyou-content",
        );
        if (!panel) {
          return;
        }
        const visible = this.showContent;
        panel.classList.toggle(
          "vg-confirmation-panel--thankyou-content-hidden",
          !visible,
        );
        panel.toggleAttribute("aria-hidden", !visible);
      });
    },
    safeInjectTrustedScripts() {
      try {
        this.injectTrustedScripts();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[ThankYouRichContent] injectTrustedScripts failed", e);
      }
    },
    safeRemoveInjectedScripts() {
      try {
        this.removeInjectedScripts();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("[ThankYouRichContent] removeInjectedScripts failed", e);
      }
    },
    injectTrustedScripts() {
      if (typeof document === "undefined" || !this.showContent) return;

      const descriptors = extractTrustedScripts(this.html || "");
      if (descriptors.length === 0) return;

      const host = this.$el?.querySelector?.(".vg-thankyou-rich-content");
      if (!host || !host.appendChild) return;

      for (const d of descriptors) {
        const script = document.createElement("script");
        script.src = d.src;
        if (d.async) script.async = true;
        if (d.defer) script.defer = true;
        if (d.type) script.type = d.type;
        if (d.crossorigin) script.crossOrigin = d.crossorigin;
        host.appendChild(script);
        this.injectedScripts.push(script);
      }
    },
    removeInjectedScripts() {
      if (!Array.isArray(this.injectedScripts)) return;
      for (const s of this.injectedScripts) {
        if (s && s.parentNode) {
          s.parentNode.removeChild(s);
        }
      }
      this.injectedScripts = [];
    },
  },
};
</script>

<style scoped>
.rich-offer-content {
  display: block;
  width: 100%;
}
.rich-offer-content .rich-offer-html {
  width: 100%;
}
</style>
